import React, { useEffect, useState } from 'react';
import TryOnForm from './components/TryOnForm';
import SignInBar from './components/SignInBar';
import AdminPage from './components/AdminPage';
import './app.css';

function App() {
  const [route, setRoute] = useState(() => window.location.pathname);
  const [adminVerified, setAdminVerified] = useState(() => {
    try { return sessionStorage.getItem('adminVerified') === '1'; } catch { return false; }
  });
  const [isDebug, setIsDebug] = useState(false);
  useEffect(() => {
    const onPop = () => setRoute(window.location.pathname);
    window.addEventListener('popstate', onPop);
    const onAdminVerified = (e) => setAdminVerified(!!(e && e.detail));
    window.addEventListener('admin-verified', onAdminVerified);
    const onVis = () => {
      try { setAdminVerified(sessionStorage.getItem('adminVerified') === '1'); } catch {}
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('admin-verified', onAdminVerified);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  useEffect(() => {
    // Detect backend debug mode from /health
    fetch('/health', { credentials: 'include' }).then(async (r) => {
      try {
        const j = await r.json();
        if (j && typeof j.debug === 'boolean') setIsDebug(j.debug);
      } catch {}
    }).catch(() => {});
  }, []);

  if (route === '/admin') {
    return <AdminPage />;
  }

  return (
    <div>
      {isDebug && adminVerified && (
        <div style={{display:'flex', justifyContent:'flex-end', alignItems:'center', gap:8, padding:'6px 10px', background:'#f8fafc', borderBottom:'1px solid #e2e8f0'}}>
          <span style={{fontSize:'0.8rem', color:'#065f46', background:'#ecfdf5', border:'1px solid #a7f3d0', padding:'2px 6px', borderRadius:999}}>Admin verified</span>
          <a href="/admin" onClick={(e)=>{ e.preventDefault(); window.history.pushState({}, '', '/admin'); setRoute('/admin'); }} style={{fontSize:'0.9rem', color:'#64748b', textDecoration:'none', border:'1px solid #cbd5e1', padding:'3px 8px', borderRadius:6}}>Admin</a>
        </div>
      )}
      <SignInBar />
      <header className="app-header">
        <a href="https://drive-tech-ai.com/" target="_blank" rel="noopener noreferrer" style={{display:'inline-flex', alignItems:'center'}}>
          <img src={`${process.env.PUBLIC_URL}/logo_DriveTechAI_128_c.png`} alt="DriveTechAI logo" />
        </a>
        <div>
          <h1>
            AI Outfit Planner by{' '}
            <a href="https://drive-tech-ai.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'none' }}>
              DriveTechAI
            </a>
          </h1>
          <div style={{fontSize:'0.9rem', color:'#8b5e3c', marginTop:'0.15rem'}}>Your personalised AI-Powered VirtualTryOn Fashion App, Try Before Buy</div>
        </div>
      </header>
      <TryOnForm />
      <footer className="app-footer">
        <div className="footer-inner">
          <div>
            <a href="https://drive-tech-ai.com/" target="_blank" rel="noopener noreferrer">Home</a>
            <span className="footer-sep">•</span>
            <a href="https://drive-tech-ai.com/articles/" target="_blank" rel="noopener noreferrer">TechLens</a>
            <span className="footer-sep">•</span>
            <span className="footer-icon" aria-hidden="true" title="Contact">✉</span>
            <a href="mailto:contact@drive-tech-ai.com" style={{ marginLeft: '0.25rem' }}>contact@drive-tech-ai.com</a>
            <span className="footer-sep">•</span>
            <span className="footer-icon" aria-hidden="true" title="Contact Page">🔗</span>
            <a href="https://drive-tech-ai.com/articles/contact/" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '0.25rem' }}>Contact Page</a>
            <span className="footer-sep">•</span>
            <a href="https://www.linkedin.com/company/drive-tech-ai/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <span className="footer-sep">•</span>
            <a href="https://x.com/DriveTechAI" target="_blank" rel="noopener noreferrer">X</a>
              <span className="footer-sep">•</span>
              <span className="footer-brown">© {new Date().getFullYear()} DriveTechAI</span>
          </div>
          
          <div className="footer-break">
            Application credit :
            {' '}
            <a href="https://www.linkedin.com/in/sharad-bhadgaonkar/" target="_blank" rel="noopener noreferrer">
              Sharad Bhadgaonkar
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
